import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ErrorCode } from '../models/error-code.enum';
import { AppConfig } from '../services/app-config.service';
import { Router } from '@angular/router';

@Injectable()
export class ReadOnlyInterceptor implements HttpInterceptor {

  constructor(
    private appConfig: AppConfig,
    private router: Router
    ) {
  }

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const urlFragments: string[] = request.url.split('/');
    const isRequestSentFromAdminPanel: boolean = this.router.url.split('/')[1] === 'admin';
    const isRequestBannerDismissal: boolean = urlFragments[urlFragments.length - 2] === 'banners';
    if (!this.appConfig.config.applicationReadOnlyMode
      || request.method === 'GET'
      || this.appConfig.config.allowedRequests.includes(urlFragments[urlFragments.length - 1])
      || isRequestBannerDismissal
      || isRequestSentFromAdminPanel
    ) {
      return next.handle(request);
    } else {
      return throwError(ErrorCode.READ_ONLY);
    }

  }
}
